import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';

import {
	ORG_SETUP_INITIAL,
	ORG_SETUP_NEEDS_AUTH,
	ORG_SETUP_INTERMISSION,
	NXT_CRM,
	DONORPERFECT_CRM,
} from 'src/utils/authOrg.constants';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import { requestUpdateAuthUser } from 'src/redux/authUsers/authUser.action';
import styles from '../index.css';
import { Heading, Paragraph, HyperLink, FlexBox } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class TermsOfUse extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	marketingWebsite = 'https://fundraisewisely.com';

	acceptTermsOfUse = () => {
		if (this.state.viewedTerms) {
			const needsAuthCRMs = [NXT_CRM, DONORPERFECT_CRM];
			this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
				setup_state: needsAuthCRMs.includes(this.props.authOrganizations[0].crm_type)
					? ORG_SETUP_NEEDS_AUTH
					: ORG_SETUP_INTERMISSION,
				terms_accepted_on: new Date(),
				terms_accepted_by: this.props.currentAuthUser._id,
			});
		}
	};

	viewTermsOfUse = () => {
		window.open(`${this.marketingWebsite}/terms-no-header`, '_blank');
		this.setState({ viewedTerms: true });
	};

	render() {
		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== ORG_SETUP_INITIAL) {
			return <Redirect to={{ pathname: '/' }} />;
		}

		return (
			<FlexBox className={styles.SetupCardLayout} flexDirection="column">
				<Heading {...theme.heading.setUpTitle}>Welcome to Wisely!</Heading>
				<Paragraph>Please review and accept the Terms of Use below to proceed.</Paragraph>
				<RoundedRectangleButton
					className={styles.DefaultButton}
					fontSize="16px"
					onClick={this.viewTermsOfUse}
				>
					View terms of use
				</RoundedRectangleButton>
				<RoundedRectangleButton
					className={styles.DefaultButton}
					fontSize="16px"
					disabledBackgroundColor="#D4D7E4"
					disabled={!this.state.viewedTerms}
					onClick={this.acceptTermsOfUse}
				>
					Accept terms of use
				</RoundedRectangleButton>
				<Paragraph>
					You might also want to check out our{' '}
					<HyperLink
						href={`${this.marketingWebsite}/privacy-no-header`}
						target="_blank"
						rel="noopener noreferrer"
					>
						Privacy Policy
					</HyperLink>{' '}
					and{' '}
					<HyperLink
						href={`${this.marketingWebsite}/pricing`}
						target="_blank"
						rel="noopener noreferrer"
					>
						Pricing Page
					</HyperLink>
					.
				</Paragraph>
			</FlexBox>
		);
	}
}

const actions = {
	requestUpdateAuthOrganization,
	requestUpdateAuthUser,
};

TermsOfUse = connect(null, actions)(TermsOfUse);

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/TermsOfUse/index.js